import React, { useState } from "react"
import ReactDOM from 'react-dom/client';

import PropTypes from "prop-types"
import View from "./view"
// import ViewSwitcher from "./view-switcher"

const defaultView = () => window.productConfigurable == "1" ? "specify" : "list";
function Configurator({ modelName, modelCode, defaultAccessory, type }){
      const [activeView, setActiveView] = useState( defaultView() );

    return ( 
    <div className="configurator">
        <View activeView={activeView} modelName={modelName} modelCode={modelCode}  defaultAccessory={defaultAccessory} type="ostendoProduct" />
    </div>
    )
}
Configurator.propTypes = {
 	  modelName: PropTypes.string,
};   
    
const root = document.querySelector(".js-configurator")

if (root ) {

    const modelName = root.getAttribute("data-model-name")
    const modelCode = root.getAttribute("data-model-code")
    const defaultAccessory = root.getAttribute("data-default-accessory")
    window.showPhotometricButton = root.getAttribute("data-show-photometric-button")
    const rootElement = ReactDOM.createRoot( root );

    rootElement.render(
        <Configurator modelName={modelName} modelCode={modelCode} defaultAccessory={defaultAccessory}  />
    )
}

const defaultView1 = () => window.productAccessories == "1" ? "specify" : "list";
    
function Configurator1({ modelName, modelCode, defaultAccessory, type }){
          const [activeView, setActiveView] = useState( defaultView1() );

    return (
        <div className="configurator">
            <View activeView={activeView} modelName={modelName} modelCode={modelCode}  defaultAccessory={defaultAccessory}  type="ostendoProduct" />
        </div>
     )
}
Configurator1.propTypes = {
 	  modelName: PropTypes.string,
};  
const root1 = document.querySelector(".js-accessories")

if ( root1  ) {
    const modelName1 = root1.getAttribute("data-model-name")
    const modelCode1 = root1.getAttribute("data-model-code")
    const defaultAccessory1 = root1.getAttribute("data-default-accessory")
    window.showPhotometricButton = root1.getAttribute("data-show-photometric-button")
    const root1Element = ReactDOM.createRoot( root1 );

    root1Element.render(
        <Configurator1 modelName={modelName1} modelCode={modelCode1} defaultAccessory={defaultAccessory1} />
    )
}
 const defaultView2 = () => window.productConfigurable == "1" ? "enquiry-popup" : "list";

function Configurator2({ modelName, modelCode,  defaultAccessory, type }){
    const [activeView, setActiveView] = useState( defaultView2() );

    return (<div className="configurator">
                <View activeView={activeView} modelName={modelName} modelCode={modelCode} defaultAccessory={defaultAccessory} type="ostendoProduct"  />
            </div>)
}
Configurator2.propTypes = {
 	  modelName: PropTypes.string,
};      

const root2 = document.querySelector(".js-enquiryform")

if ( root2 ) {
    const modelName2 = root2.getAttribute("data-model-name")
    const modelCode2 = root2.getAttribute("data-model-code")
    const defaultAccessory2 = root2.getAttribute("data-default-accessory")
    window.showPhotometricButton = root2.getAttribute("data-show-photometric-button")
    const root2Element = ReactDOM.createRoot( root2 );

    root2Element.render(
        <Configurator2 modelName={modelName2} modelCode={modelCode2} defaultAccessory={defaultAccessory2} />
    )
}

const defaultView3 = () =>  "accessories";
function Configurator3({ modelName, modelCode, defaultAccessory, type }){
    const [activeView, setActiveView] = useState( defaultView3() );

    return (<div className="configurator">
        <View activeView={activeView} modelName={modelName} modelCode={modelCode}  defaultAccessory={defaultAccessory} type="ostendoAccessory"   />
    </div>)
}
Configurator3.propTypes = {
 	  modelName: PropTypes.string,
};    

const root3 = document.querySelector(".js-accessories-new")
if (root3 ) {
    const modelName3 = root3.getAttribute("data-model-name")
    const modelCode3 = root3.getAttribute("data-model-code")
    const defaultAccessory3 = root3.getAttribute("data-default-accessory")
    window.showPhotometricButton = root3.getAttribute("data-show-photometric-button")
    const root3Element = ReactDOM.createRoot( root3 );

    root3Element.render(
        <Configurator3 modelName={modelName3} modelCode={modelCode3} defaultAccessory={defaultAccessory3} />
    )
}